document.querySelectorAll('.milla-product-hero__purchase').forEach((panel) => {
  const quantityInput = panel.querySelector('.milla-product-hero__quantity-input');
  const decreaseButton = panel.querySelector('[data-action="decrease"]');
  const increaseButton = panel.querySelector('[data-action="increase"]');

  if (!quantityInput || !decreaseButton || !increaseButton) return;

  const updateQuantity = (nextValue) => {
    const min = Number(quantityInput.min) || 1;
    const max = Number(quantityInput.max) || 99;
    const value = Math.min(max, Math.max(min, nextValue));
    quantityInput.value = String(value);
  };

  decreaseButton.addEventListener('click', () => {
    updateQuantity(Number(quantityInput.value) - 1);
  });

  increaseButton.addEventListener('click', () => {
    updateQuantity(Number(quantityInput.value) + 1);
  });

  quantityInput.addEventListener('change', () => {
    updateQuantity(Number(quantityInput.value));
  });
});

